import React from "react";
import { Card, Typography, Row, Col, Button, Space } from "antd";
import ReviewImg1 from "../../assets/images/ReviewImg1.svg";
import ReviewImg2 from "../../assets/images/ReviewImg2.svg";
import ReviewImg3 from "../../assets/images/ReviewImg3.svg";

const { Text, Title } = Typography;

const reviews = [
  {
    logo: ReviewImg1,
    content:
      "Hostinger is our number one pick for several reasons. When testing its service compared to others, our site performed the best while being hosted on Hostinger.",
  },
  {
    logo: ReviewImg2,
    content:
      "After running multiple tests on the Hostinger side, the average response time was between 450ms and 625ms, which is very good. Simply put, speed should not be an issue when using Hostinger.",
  },
  {
    logo: ReviewImg3,
    content:
      "For companies with a small or non-existent IT staff, expert customer service is a huge perk. It is the best option if you're searching specifically for a shared hosting service that's affordable and reliable.",
  },
];

const Review = () => {
  return (
    /* FULL WHITE SECTION */
    <div style={{ width: "100%", background: "#ffffff" }}>
      {/* CENTERED CONTENT */}
      <div
        style={{
          maxWidth: 1208,
          margin: "0 auto",
          padding: "40px 16px 80px",
        }}
      >
        {/* REVIEWS */}
        <Row gutter={[24, 24]} justify="center">
          {reviews.map((item, index) => (
            <Col key={index} xs={24} md={12} lg={8}>
              <Card
                bordered
                style={{
                  width: "100%",
                  maxWidth: 360,
                  height: 259,
                  margin: "0 auto",
                  borderRadius: 8,
                  border: "1px solid #e6eaff",
                  background: "#ffffff",
                }}
                bodyStyle={{
                  padding: 24,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* LOGO */}
                <img
                  src={item.logo}
                  alt="review source logo"
                  style={{
                    height: 24,
                    marginBottom: 16,
                    objectFit: "contain",
                  }}
                />

                {/* CONTENT */}
                <Text
                  style={{
                    fontSize: 14,
                    lineHeight: 1.7,
                    color: "#2d1e6b",
                  }}
                >
                  {item.content}
                </Text>
              </Card>
            </Col>
          ))}
        </Row>

        {/* CTA SECTION (INSIDE REVIEWS) */}
        <div style={{ marginTop: 80, textAlign: "center" }}>
          <Space direction="vertical" size={24} align="center">
            <Title
              level={2}
              style={{
                margin: 0,
                color: "#2d1e6b",
                fontWeight: 700,
              }}
            >
              Get started with high-speed hosting
            </Title>

            <Button
              type="primary"
              size="large"
              style={{
                background: "#673DE6",
                borderRadius: 8,
                height: 48,
                padding: "0 32px",
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              See pricing
            </Button>

            <Text style={{ fontSize: 13, color: "#2d1e6b" }}>
              30-Day Money-Back Guarantee
            </Text>
          </Space>
        </div>
      </div>
    </div>
  );
};

export default Review;
